import React from 'react';

const MenuIcon = ({ size = '28px', className = '' }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
    >
      {/* Menu Lines */}
      <rect 
        width="19.386" 
        height="3.497" 
        x="5.282" 
        y="5.58" 
        rx="0.6" 
        fill="currentColor"
      />
      <rect 
        width="13.879" 
        height="3.497" 
        x="5.925" 
        y="13.83" 
        rx="0.6" 
        fill="currentColor"
      />
      <rect 
        width="19.386" 
        height="3.497" 
        x="5.282" 
        y="22.08" 
        rx="0.6" 
        fill="currentColor"
      />
      {/* Play Button Triangle */}
      <path 
        d="M27.797 14.714a1 1 0 0 1 0 1.728l-4.178 2.432a1 1 0 0 1-1.503-.864v-4.863a1 1 0 0 1 1.503-.865l4.178 2.432Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default MenuIcon;
